<template>
  <div>
    <NewNavbar variant="standard" />
    <nuxt />
  </div>
</template>

<script>
import { authenticated } from '@/mixins/layouts'
import metaMixin from '@/mixins/meta'
import NewNavbar from '@/components/NewNavbar'

export default {
  name: 'HomePageLayout',
  middleware: 'homepage',
  components: {
    NewNavbar
  },
  mixins: [authenticated, metaMixin],
  head () {
    return {
      title: this.metaTitle
    }
  }
}
</script>
